<h3>CSV Version</h3>
<br/>
<span>Zuletzt aktualisiert: <b>{{ csvResult }}</b></span>